import { render, staticRenderFns } from "./FestivalStatCard.vue?vue&type=template&id=09564d4f&scoped=true&"
import script from "./FestivalStatCard.vue?vue&type=script&lang=js&"
export * from "./FestivalStatCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09564d4f",
  null
  
)

export default component.exports